export default __webpack_public_path__ + "3c4d04fdaad20fbd3899d5248a7c0a2d.png";